import { modelOptions, prop } from '@typegoose/typegoose';
import mongoose from 'mongoose';
import { ScoreBreakdown } from './riskManagement.common.model';

@modelOptions({
  schemaOptions: { collection: 'companyUserState' },
  options: { customName: 'companyUserState' },
})
export class CompanyUserStateModel {
  @prop({ required: true })
  companyId: mongoose.Types.ObjectId;

  @prop({ required: true, type: ScoreBreakdown })
  scoreBreakdown: ScoreBreakdown;

  @prop()
  uniqueIdentifier: string;

  @prop()
  username: string;

  @prop()
  userType: number[];

  @prop()
  status: number;

  @prop()
  state: number;

  @prop()
  operatingSystems?: number[];

  @prop()
  // TODO: refactor as Model once needed
  devices: Array<{
    type: number;
    items: Array<{
      endpointId: mongoose.Types.ObjectId;
      indicators: Array<{
        indicatorId: number;
        occurrences: number;
      }>;
    }>;
    count: number;
  }>;
}
